import { select, call, put } from "redux-saga/effects";
import { registerShopper as registerShopperPromise } from "@bitComponents/adabyron/register";
import { IDENTIFICATION_DOCUMENT_TYPES } from "@bitComponents/utils/validators";
import { WEB_SERVICES } from "./webServices";
import { MASKS } from "../constants/uxConstants";

const contextStore = (state) => state.context.data;

const CONTACT_MEANS_TCOL_TYPE = {
  MAIL: {
    value: "4",
  },
  MOBILE_PHONE: {
    value: "2",
  },
};

const TCOL_DOCUMENT_TYPES = {
  DNI: "NIF_",
  NIE: "NIE_",
  PASSPORT: "PASA",
};

const normalizeRegisterShopperRequest = ({
  name,
  firstSurname,
  secondSurname,
  documentType,
  documentNumber,
  nationality,
  contactPhone,
  email,
  environment,
}) => {
  const contactMeans = [];
  let smsOTP = true;
  let emailOTP = false;
  if (environment && environment.name !== "prod") {
    smsOTP = false;
    emailOTP = true;
  }
  const mailMean = {
    value: email,
    contactTypeTCOL: CONTACT_MEANS_TCOL_TYPE.MAIL.value,
    favourite: true,
    sendOTP: emailOTP,
  };
  
  const contactPhoneValueToSend = contactPhone.replaceAll(MASKS.phone.separator,'');
  const phoneMean = {
    value: contactPhoneValueToSend,
    contactTypeTCOL: CONTACT_MEANS_TCOL_TYPE.MOBILE_PHONE.value,
    favourite: true,
    sendOTP: smsOTP,
  };
  contactMeans.push(mailMean);
  contactMeans.push(phoneMean);
  let normalizedDocumentType = TCOL_DOCUMENT_TYPES.DNI;
  switch (documentType) {
    case IDENTIFICATION_DOCUMENT_TYPES.NIE:
      normalizedDocumentType = TCOL_DOCUMENT_TYPES.NIE;
      break;
    case IDENTIFICATION_DOCUMENT_TYPES.PASSPORT:
      normalizedDocumentType = TCOL_DOCUMENT_TYPES.PASSPORT;
      break;
    default:
      break;
  }
  const args = {
    clientName: name,
    firstSurName: firstSurname,
    secondSurName: secondSurname,
    documentType: normalizedDocumentType,
    documentNumber,
    nationality,
    contactMeans,
  };
  return args;
};

export function* registerShopper(params) {
  const {
    reduxUpdate,
    name,
    firstSurname,
    secondSurname,
    documentType,
    documentNumber,
    nationality,
    contactPhone,
    email,
    normalizeHttpErrors,
  } = params;
  try {
    const context = yield select(contextStore);
    const { environment } = context;
    const { successUpdate } = reduxUpdate;
    const args = normalizeRegisterShopperRequest({
      name,
      firstSurname,
      secondSurname,
      documentType,
      documentNumber,
      nationality,
      contactPhone,
      email,
      environment,
    });
    const response = yield call(registerShopperPromise, args, context);
    if(successUpdate){
      yield put(successUpdate(response));
    }
    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(
      normalizeHttpErrors,
      WEB_SERVICES.UPDATE_CQ,
      error
    );
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}
